export var PaymentTypesIdEnum;
(function (PaymentTypesIdEnum) {
    PaymentTypesIdEnum[PaymentTypesIdEnum["Unsupported"] = 0] = "Unsupported";
    PaymentTypesIdEnum[PaymentTypesIdEnum["CreditCard"] = 1] = "CreditCard";
    PaymentTypesIdEnum[PaymentTypesIdEnum["DebitCard"] = 2] = "DebitCard";
    PaymentTypesIdEnum[PaymentTypesIdEnum["PayPal"] = 14] = "PayPal";
    PaymentTypesIdEnum[PaymentTypesIdEnum["ApplePay"] = 31] = "ApplePay";
    PaymentTypesIdEnum[PaymentTypesIdEnum["GooglePay"] = 32] = "GooglePay";
    PaymentTypesIdEnum[PaymentTypesIdEnum["ENBD"] = 28] = "ENBD";
    PaymentTypesIdEnum[PaymentTypesIdEnum["CpgHostedCard"] = 36] = "CpgHostedCard";
    PaymentTypesIdEnum[PaymentTypesIdEnum["HostedCard"] = 35] = "HostedCard";
})(PaymentTypesIdEnum || (PaymentTypesIdEnum = {}));
export var PaymentCardTypeIdEnum;
(function (PaymentCardTypeIdEnum) {
    PaymentCardTypeIdEnum[PaymentCardTypeIdEnum["PayPalV2"] = 365] = "PayPalV2";
    PaymentCardTypeIdEnum[PaymentCardTypeIdEnum["PayPalPayLater"] = 366] = "PayPalPayLater";
    PaymentCardTypeIdEnum[PaymentCardTypeIdEnum["CpgHostedCard"] = 370] = "CpgHostedCard";
    PaymentCardTypeIdEnum[PaymentCardTypeIdEnum["HostedCard"] = 369] = "HostedCard";
})(PaymentCardTypeIdEnum || (PaymentCardTypeIdEnum = {}));
export var PaymentMethodsEnum;
(function (PaymentMethodsEnum) {
    PaymentMethodsEnum["CARD"] = "card";
    PaymentMethodsEnum["PAYPAL"] = "paypal";
    PaymentMethodsEnum["PAYPAL_V2"] = "paypalv2";
    PaymentMethodsEnum["PAYPAL_PAY_LATER"] = "paylater";
    PaymentMethodsEnum["APPLE_PAY"] = "apple";
    PaymentMethodsEnum["G_PAY"] = "gpay";
    PaymentMethodsEnum["ENBD"] = "enbd";
    PaymentMethodsEnum["OPENBANKING"] = "openbanking";
    PaymentMethodsEnum["CPG_HOSTEDCARD"] = "cpghostedcard";
    PaymentMethodsEnum["HOSTEDCARD"] = "hostedcard";
})(PaymentMethodsEnum || (PaymentMethodsEnum = {}));
